import styled from "styled-components";
import img from './bg.png'

export const StyledSignIn = styled.div`
  height: 100vh;
  width: 100%;
  background-image: url(${img}); 
  background-image: url('https://img.freepik.com/free-photo/top-view-hardback-books-with-copy-space_23-2148827214.jpg?t=st=1720867124~exp=1720870724~hmac=a4d2a78826be3fdf014802c3090a5221b91336ed5f1e7158dbc266fcfb9a60b5&w=996');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  display: flex;
  align-items: center;
  justify-content: center;
`;
